import styled from '@emotion/styled';
import { Button, Space, Table } from 'antd';
import { orderBy } from 'lodash';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { FaDownload } from 'react-icons/fa';
import { FiBook } from 'react-icons/fi';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { ConnectedUserEntity } from '../../../../entities/ConnectedUserEntity';
import { GrandLivreEntity } from '../../../../entities/grandLivre.entity';
import { ROUTES } from '../../../../routes';
import { PRIMARY, YELLOW } from '../../../../shared/colors';
import { formatNum } from '../../../../shared/constants';
import { Layout } from '../../../shared/Layout';
import { exportGLData } from '../components/exportDataExcel';
import { getGrandLivre } from '../network';

const Container = styled.div`
  height: calc(100vh - 30px);
  display: flex;
  background-color: #1c2025;
  color: white;

  .bread-crum span {
    color: white;
  }

  td.ant-table-column-sort {
    background-color: transparent !important;
  }

  th {
    background-color: ${PRIMARY} !important;
    color: white !important;
    font-weight: bold;
  }

  .odd-row {
    background-color: #757575;
    color: white;
  }

  .even-row {
    background-color: #acacac;
    color: white;
  }

  .odd-row,
  .even-row {
    &:hover > td {
      background-color: ${YELLOW} !important;
      cursor: pointer;
      color: black; /* plus lisible */
    }
  }

  .content {
    padding: 50px;
    width: 100%;
    background-color: #1c2025;
    color: white;
  }
`;

export const GrandLivrePage = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [grandLivre, setGrandLivre] = useState<GrandLivreEntity[]>([]);
  const history = useHistory();
  const connectedUser: ConnectedUserEntity = useSelector(
    (state: any) => state.userReducer,
  ).user;

  useEffect(() => {
    getGrandLivre(connectedUser.id).then(({ data }) => {
      setGrandLivre(orderBy(data, 'created_at', 'desc'));
      setIsLoading(false);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Layout>
      <Container>
        {/** Obtain 'current' values in Sidebar component */}
        <div className='content'>
          <h2 style={{ marginTop: 10, color: 'white' }}>
            Comptabilité - Grand livre
          </h2>
          <div style={{ marginTop: 5 }}>
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                marginBottom: 5,
              }}
            >
              <div></div>

              <Space>
                <Button
                  icon={<FiBook style={{ marginBottom: -2, marginRight: 5 }} />}
                  className='butt'
                  style={{ borderRadius: 5 }}
                  onClick={() =>
                    history.push(ROUTES.PANEL.COMPTABILITE.BALANCE_G)
                  }
                >
                  Balance Générale
                </Button>
                <Button
                  icon={
                    <FaDownload style={{ marginBottom: -2, marginRight: 5 }} />
                  }
                  className='butt'
                  style={{ borderRadius: 5 }}
                  onClick={() => exportGLData(grandLivre)}
                >
                  Exporter
                </Button>
              </Space>
            </div>

            <Table
              columns={COLUMNS}
              dataSource={grandLivre}
              rowClassName={(row, index) =>
                index % 2 === 0 ? 'even-row' : 'odd-row'
              }
              size='small'
              loading={isLoading}
              style={{ zoom: 0.9 }}
              pagination={{
                defaultPageSize: 50,
                position: ['bottomRight'],
                showSizeChanger: true,
                pageSizeOptions: ['50', '100', '200', '250'],
              }}
              scroll={{ x: 'max-content' }}
            />
          </div>
        </div>
      </Container>
    </Layout>
  );
};

const COLUMNS = [
  {
    title: 'Numéro de compte',
    dataIndex: 'num_compte',
  },
  {
    title: 'Intitulé',
    dataIndex: 'intitule_compte',
  },
  {
    title: 'Date saisi',
    dataIndex: 'date_saisi',
    render: (cell: any) => `${moment(cell).format('DD/MM/YYYY')}`,
  },
  {
    title: 'Date document',
    dataIndex: 'date_document',
    render: (cell: any) => `${moment(cell).format('DD/MM/YYYY')}`,
  },
  {
    title: 'Document',
    dataIndex: 'document',
  },
  {
    title: 'Pièce',
    dataIndex: 'piece',
  },
  {
    title: 'Libellé',
    dataIndex: 'libelle',
  },
  {
    title: 'Catégorie Titre',
    dataIndex: 'categorie_titre',
  },
  {
    title: 'Trésor emetteur',
    dataIndex: 'tresor_emetteur',
  },
  {
    title: 'Titulaire',
    dataIndex: 'titulaire',
  },
  {
    title: 'Crédit',
    dataIndex: 'credit',
    render: (cell: any) => `${formatNum(cell)}`,
  },
  {
    title: 'Débit',
    dataIndex: 'debit',
    render: (cell: any) => `${formatNum(cell)}`,
  },
  {
    title: 'Solde',
    dataIndex: 'solde',
    render: (cell: any) => `${formatNum(cell)}`,
  },
];
